import { rgba } from "polished";
import * as React from "react";
import styled from "styled-components";

import { LoginLayout, LoginLayoutProps } from "@com.mgmtp.a12.widgets/widgets-core/lib/layout/login-layout";
import { SizeContext } from "@com.mgmtp.a12.widgets/widgets-core/lib/layout/size-detector";

import { ApplicationBanner } from "./ApplicationBanner";

interface SmallBoxLayoutProps {
	readonly content: React.ReactNode;
	readonly footer?: React.ReactNode;
	readonly showApplicationBanner?: boolean;
}

export const SmallBoxLayout: React.ComponentType<SmallBoxLayoutProps & Pick<LoginLayoutProps, "fullscreen">> =
	function SmallBoxLayout({ content, footer, showApplicationBanner, fullscreen }) {
		const { currentSize } = React.useContext(SizeContext);
		const mobile = ["xs", "sm"].includes(currentSize ?? "");

		// CustomLoginLayoutContainer muss mit noGutter verwendet werden sonst wird es zweimal mit LoginLayout.Container gewrappt
		return (
			<LoginLayout
				fullscreen={fullscreen}
				noGutter
				mobile={mobile}
				backgroundImage="assets/images/monochrom_background.svg"
				style={{ width: "100%" }}
			>
				<CustomLoginLayoutContainer>
					<LoginLayout.Form>
						<LoginLayout.FormItem>{content}</LoginLayout.FormItem>
					</LoginLayout.Form>
					{showApplicationBanner && <ApplicationBanner verticalSpacing />}
					{footer && <LoginLayout.Footer>{footer}</LoginLayout.Footer>}
				</CustomLoginLayoutContainer>
			</LoginLayout>
		);
	};

const CustomLoginLayoutContainer = styled(LoginLayout.Container)`
	box-shadow: 0px 0px 20px 0px ${({ theme }) => rgba(theme.colors.boxShadowBackground, 0.4)};
`;
